import React from "react";
import { Link, useLocation } from "react-router-dom";

const items = [
  { to: "/admin", label: "// DESIGNS", testid: "nav-designs" },
  { to: "/admin/orders", label: "// ORDERS", testid: "nav-orders" },
  { to: "/admin/finance", label: "// FINANCE", testid: "nav-finance" },
  { to: "/admin/discounts", label: "// DISCOUNTS", testid: "nav-discounts" },
  { to: "/admin/abandoned", label: "// RECOVERY", testid: "nav-abandoned" },
  { to: "/admin/logo", label: "// LOGO STUDIO", testid: "nav-logo" },
];

const AdminNav = () => {
  const { pathname } = useLocation();
  return (
    <div className="grid grid-cols-2 lg:grid-cols-6 gap-2 mb-8" data-testid="admin-subnav">
      {items.map((it) => {
        const active = pathname === it.to || (it.to === "/admin" && pathname === "/admin/");
        return (
          <Link
            key={it.to}
            to={it.to}
            data-testid={it.testid}
            className={`btn-raw text-center text-xs ${active ? "border-[#d4af37] text-[#d4af37]" : ""}`}
          >
            {it.label}
          </Link>
        );
      })}
    </div>
  );
};

export default AdminNav;
